import { Component, OnDestroy, OnInit, HostListener } from '@angular/core';
import {
  Event,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { ROUTES } from '../sidebar/sidebar.component';
import { environment } from 'src/environments/environment';
import { User } from '../../_models/user';
import { AuthenticationService } from '../../_services/authentication.service';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { GeneralService } from 'src/app/_services/general.service';
import { MixpanelService } from '../../services/mixpanel.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, OnDestroy {
  public focus;
  public listTitles: any[];
  public location: Location;
  sidenavOpen: boolean = true;
  currentUser: User;
  tenantId: string;
  sub$ = new Subscription();
  accounts: Map<string, User> | null = null;
  logo = environment.envVar.LOGO_WHITE;
  isMobileMenuOpen = false;
  isSupportWidgetOpen = false;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window.innerWidth >= 992 && this.isMobileMenuOpen) {
      this.isMobileMenuOpen = false;
      document.body.style.overflow = '';
    }
  }

  menuLinks = [
    {
      title: 'Apps',
      link: '/apps',
    },
    {
      title: 'Gateways',
      link: '/gateways',
    },
    {
      title: 'Devices',
      link: '/devices',
    },
    {
      divider: true,
    },
    {
      title: 'Settings',
      link: '/settings',
      icon: 'fa-solid fa-cog',
    },
    {
      title: 'Support',
      action: 'support',
      icon: 'fa-solid fa-life-ring',
    },
  ];

  constructor(
    location: Location,
    private router: Router,
    private authenticationService: AuthenticationService,
    private generalService: GeneralService,
    private mixpanelService: MixpanelService
  ) {
    this.location = location;

    this.authenticationService.currentAllAccountsValue.subscribe(accounts => {
      this.accounts = accounts;
    });

    const userSub$ = this.authenticationService.currentAccountValue.subscribe(
      x => {
        if (x) {
          this.currentUser = x;
          this.tenantId = x.tenantId;
        }
      }
    );
    // const authSub$ = this.authenticationService.tenantId.subscribe(
    //   x => (this.tenantId = x.toUpperCase())
    // );
    const routerSub$ = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
      }
      if (event instanceof NavigationEnd) {
        // Hide loading indicator
        this.isMobileMenuOpen = false;
        document.body.style.overflow = '';

        if (window.innerWidth < 1200) {
          document.body.classList.remove('g-sidenav-pinned');
          document.body.classList.add('g-sidenav-hidden');
          this.sidenavOpen = false;
        }
      }

      if (event instanceof NavigationError) {
        // Hide loading indicator

        // Present error to user
        console.log(event.error);
      }
    });
    this.sub$.add(userSub$);
    // this.sub$.add(authSub$);
    this.sub$.add(routerSub$);
  }

  ngOnDestroy(): void {
    this.sub$.unsubscribe();
  }

  ngOnInit() {
    this.listTitles = ROUTES.filter(listTitle => listTitle);
  }

  search(event) {
    let searchTerm = event.target.value;
    this.mixpanelService.track('Search Performed', {
      search_term: searchTerm,
      tenant_id: this.tenantId,
      user_id: this.currentUser?._id,
    });
    this.router.navigate([`/search/${searchTerm}`]);
  }

  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(1);
    }

    for (var item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        return this.listTitles[item].title;
      }
    }
    return 'Dashboard';
  }

  logout() {
    this.mixpanelService.track('User Logged Out', {
      tenant_id: this.tenantId,
      user_id: this.currentUser?._id,
    });
    this.authenticationService.logout();
    this.router.navigate(['/auth/login']);
  }

  openSearch() {
    document.body.classList.add('g-navbar-search-showing');
    setTimeout(function () {
      document.body.classList.remove('g-navbar-search-showing');
      document.body.classList.add('g-navbar-search-show');
    }, 150);
    setTimeout(function () {
      document.body.classList.add('g-navbar-search-shown');
    }, 300);
  }
  closeSearch() {
    document.body.classList.remove('g-navbar-search-shown');
    setTimeout(function () {
      document.body.classList.remove('g-navbar-search-show');
      document.body.classList.add('g-navbar-search-hiding');
    }, 150);
    setTimeout(function () {
      document.body.classList.remove('g-navbar-search-hiding');
      document.body.classList.add('g-navbar-search-hidden');
    }, 300);
    setTimeout(function () {
      document.body.classList.remove('g-navbar-search-hidden');
    }, 500);
  }
  openSidebar() {
    if (document.body.classList.contains('g-sidenav-pinned')) {
      document.body.classList.remove('g-sidenav-pinned');
      document.body.classList.add('g-sidenav-hidden');
      this.sidenavOpen = false;
    } else {
      document.body.classList.add('g-sidenav-pinned');
      document.body.classList.remove('g-sidenav-hidden');
      this.sidenavOpen = true;
    }
  }
  toggleSidenav() {
    if (document.body.classList.contains('g-sidenav-pinned')) {
      document.body.classList.remove('g-sidenav-pinned');
      document.body.classList.add('g-sidenav-hidden');
      this.sidenavOpen = false;
    } else {
      document.body.classList.add('g-sidenav-pinned');
      document.body.classList.remove('g-sidenav-hidden');
      this.sidenavOpen = true;
    }
  }

  onSwitch(userId: string) {
    this.mixpanelService.track('Account Switched', {
      from_tenant_id: this.tenantId,
      from_user_id: this.currentUser?._id,
      to_user_id: userId,
    });
    this.authenticationService.switchAccount(userId);
  }

  getIconForLink(title: string): string {
    const iconMap = {
      Dashboard: 'fa-solid fa-chart-line',
      Apps: 'fa-solid fa-chart-simple',
      Devices: 'fa-solid fa-wifi',
      Gateways: 'fa-solid fa-network-wired',
      Assets: 'fa-solid fa-cube',
      Rules: 'fa-solid fa-list-check',
      Users: 'fa-solid fa-users',
      Settings: 'fa-solid fa-cog',
    };
    return iconMap[title] || 'fa-solid fa-circle';
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    document.body.style.overflow = this.isMobileMenuOpen ? 'hidden' : '';
  }

  onMobileMenuItemClick() {
    if (window.innerWidth < 992) {
      this.isMobileMenuOpen = false;
      document.body.style.overflow = '';
    }
  }

  openSupport() {
    const supportWidget = document.getElementById(
      'jsd-widget'
    ) as HTMLIFrameElement | null;
    if (this.isSupportWidgetOpen) {
      const closeButton = supportWidget?.contentDocument?.querySelector(
        '[data-testid="close"]'
      ) as HTMLElement | null;
      closeButton?.click();
      this.isSupportWidgetOpen = false;
      document.body.classList.remove('support-widget-open');
      return;
    }
    this.isSupportWidgetOpen = true;
    document.body.classList.add('support-widget-open');
    const supportButton = supportWidget?.contentDocument?.querySelector(
      '#help-button, [role="button"], button'
    ) as HTMLElement | null;
    supportButton?.click();
  }

  onNavigationClick(item: any) {
    this.mixpanelService.track('Navigation Clicked', {
      page_name: item.title,
      page_link: item.link,
      tenant_id: this.tenantId,
      user_id: this.currentUser?._id,
    });
  }
}
